if($('#pagename').val() === 'jobseekerprofile' || $('#pagename').val() === 'jobseekersetting'){

  function fixed_nav(){

      var nav  = $('#navigation > .navigation-group');
      var footer = $('#footer');
      var sticky_el = $('#fixed_nav');

      $nav = nav.height();
      $footer = footer.height();

      sticky_el.affix({offset: {top: 20 , bottom : $footer + 62} });

      sticky_el.on('affixed.bs.affix', function(){ //fixed
          $(this).css({'top':$nav + 20, 'position':''});
          $(this).next('div').show().css({'padding-top': $(this).height()});
      });
      sticky_el.on('affixed-top.bs.affix', function(){ //top
          $(this).css({'top': 'auto','position':''});
          $(this).next('div').show().css({'padding-top': '0px'});
      });
      sticky_el.on('affixed-bottom.bs.affix', function(){ //bottom
          $(this).css({'top': 'auto','position':''});
          $(this).next('div').hide();
      });
  }

  function checkCompleteness(completeness){
    if (typeof completeness == 'undefined') {
      return false
    }else{
      var msg = '';
      var current_completeness = $('#profile_completeness').val();
      if(completeness > 90){
        msg = 'Congrats! Employers will be able to view your profile and contact you directly';
      }else if(completeness < 90){
        msg = 'Please make sure your profile is 100% complete to allow employers to search and contact you directly';
      }else if (completeness == 'undefined' || completeness == undefined){
        msg = 'Congrats! Employers will be able to view your profile and contact you directly';
        completeness = current_completeness;
      }

      //will update later
      $('#profile_completeness_page, #profile_completeness_alert').html(completeness)

      return msg;
    }
  }

  function getStates(country)
  {
    if (typeof country == 'undefined') {
      return false;
    }else{

      $(".states").each(function (index) {
          $(this).hide();
          $(this).find('.help-block').remove();
          $(this).find('.has-error').removeClass('has-error');
      });

      if ( country == 'Other')
      {
          $('.states').show();
          $("#statelist").hide();
          $("#Other_state").show();

      } else if(country == ''){
          $('.states').hide();
      }else{
          $('.states').show();
          $("#statelist").show();
          $("#Other_state").hide();
          var countryName = country.toLowerCase();
          countryName = countryName.replace(" ","-");
          var request = $.ajax({
             type: 'GET',
             url:  canvas_url+'allstates/'+countryName+'.json',
             dataType: 'json'
          });


          request.done(function(data) {

              var states = data;
              var statelist = '<div class="select"><span class="caret"></span><select class="form-control required" name="new_state_id" id="new_state_id"><option value="">--Select State--</option></div>';
              for (var i=0;i<states.length;i++) {
                  statelist +='<option value="'+states[i].name+'">'+states[i].name+'</option>';
              }
              statelist +='</select>';
              $("#statelist").html(statelist);
              $("#statelist").show();
          });

          request.fail(function (jqXHR, textStatus) {
              console.log('error in loading');
          });

      }
    }
  }

  function viewMore(){

    //fix readmore js issue scrolling down on mobile
    var innerWidth = $('body').data('innerWidth');
    if (innerWidth != $(window).width()) {
        $('body').data('innerWidth', $(window).width());
    } else {
        return false;
    }

    var viewmore = '<a class="link link-reset d-block text-center b-top xs-p-10 pointer" style="margin-top: 20px;margin-left: -20px; margin-right: -20px; margin-bottom: -20px;">\
                    <h4 class="xs-mb-0 xs-mt-0">View more <i class="fa fa-chevron-down"></i></h4>\
                  </a>'
    var viewless = '<a class="link link-reset d-block text-center b-top xs-p-10 pointer" style="margin-top: 20px;margin-left: -20px; margin-right: -20px; margin-bottom: -20px;">\
                    <h4 class="xs-mb-0 xs-mt-0">View less <i class="fa fa-chevron-up"></i></h4>\
                  </a>'

    $('.profile-wrap > .profile-content').each(function(){
      $(this).readmore({
        speed: 75,
        heightMargin: 30,
        moreLink: viewmore,
        lessLink: viewless,
      });
    });
  }


  function checkWhatsappOptOut(preferredChannels, callback) {
      var originalChannels = $("#original_preferred_channel").val();
      originalChannels = JSON.parse(originalChannels);


      if(originalChannels.includes("Whatsapp") && !preferredChannels.includes("Whatsapp")){

          var jsonData = {
              platformId: waPlatformId,
              type: OTVC_TYPE_WHATSAPP,
              '_token': $('meta[name="csrf-token"]').attr('content'),
              '_method': "GET"
          };


          var request = $.ajax({
              url: canvas_url+"api/whatsapp/optOut",
              data: jsonData,
              type: 'GET',
              crossDomain: true,
              dataType: 'json'
          });


          request.done(function (data) {

              if(data.success === true) {
                  callback(true);
              }else{
                  callback(false);
              }

          });


          request.fail(function (jqXHR, textStatus) {
              callback(false);
          });

      }

  }

  $(document).ready(function(){

    //------------------------------------------------------//
    //----------------jobseeker profile -------------------//
    //init jobseeker contact
    $("#jobseeker_contact").intlTelInput({
        separateDialCode : true,
        initialCountry: "MY",
        preferredCountries: ["MY", "SG", "ID", "CN", "TW", "HK","PH", "IN"],
        onlyCountries: ["MY", "ID", "PH", "VN", "TH", "SG","CN", "IN", "PK", "BD"]
    });

    $("#jobseeker_reference_contact").intlTelInput({
        separateDialCode : true,
        initialCountry: "MY",
        preferredCountries: ["MY", "SG", "ID", "CN", "TW", "HK","PH", "IN"]
    });

    $(".telinput_contact").intlTelInput({
        separateDialCode : true,
        initialCountry: "MY",
        preferredCountries: ["MY", "SG", "ID", "CN", "TW", "HK","PH", "IN"]
    });

    $("#change_userphone").intlTelInput({
        separateDialCode : true,
        initialCountry: "MY",
        preferredCountries: ["MY", "SG", "ID", "CN", "TW", "HK","PH", "IN"],
        onlyCountries: ["MY", "ID", "PH", "VN", "TH", "SG","CN", "IN", "PK", "BD"]
    });

    const MAX_YEAR = 70;
    var now = new Date();
    var minYear = new Date();
    minYear.setYear(now.getYear() - MAX_YEAR);

    $('.date_picker').combodate({
  	      minYear: minYear.getFullYear(),
  	      smartDays: true,
  	      maxYear: n,
  	      firstItem: 'name',
  	      customClass: 'form-control text-capitalize'
  	});


  	$('#jobseeker_experience,#jobseeker_education,#edit_jobseeker_activities,#jobseeker_reference,#edit_jobseeker_reference,#jobseeker_activities,#edit_jobseeker_experience-1,#edit_jobseeker_education-1,#edit_jobseeker_experience-2,#edit_jobseeker_education-2,#edit_jobseeker_experience-3,#edit_jobseeker_education-3, #edit_jobseeker_activities-0, #edit_jobseeker_activities-1, #edit_jobseeker_activities-2').on('show.bs.modal', function (e) {
        if ($(".form-control").parents('.form-group').hasClass("has-error"))
        {
            $(".form-control").parents('.form-group').removeClass("has-error");
        }
    });


  	  //Allow input only number for salary
      $("#ae_salary, #ae_salary-1, #ae_salary-2, #ae_salary-3, #ae_salary-4, #ae_salary-5").keydown(function (e) {
          // Allow: backspace, delete, tab, escape, enter and .
          if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
              // Allow: Ctrl+A, Command+A
              (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
              // Allow: home, end, left, right, down, up
              (e.keyCode >= 35 && e.keyCode <= 40)) {
              // let it happen, don't do anything
              return;
          }
          // Ensure that it is a number and stop the keypress
          if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
              e.preventDefault();
          }
      });

    //----------------------------------------//
    //----------profile ----------------------//

    //offset for side nav
    var offset = $("#navigation").height() + 100;

    //fixed and viewmore
    fixed_nav();
    //viewMore();

    /* smooth scrolling sections */
    $('.profile-scrollspy').find('a').click(function() {

        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
          if (target.length) {
            $('html,body').animate({
              scrollTop: target.offset().top - offset
            }, 500);
            return false;
          }
        }
    });

    //init scroll spy
    $('body').scrollspy({target: ".profile-scrollspy",offset: offset});




  	//----------jobseeker intro --------------//
  	$('#form_jobseeker_intro').validate({
  		rules: {
  			name: {required:true},
  			personal_description: {required:true},
  			jobseeker_expected_salary : {required:true,digits: true},
              profile_industry_id: {required:true}
  		},
  		messages: {
  			name: {required:'This field is required'},
  			personal_description: {required:'This field is required'},
  			jobseeker_expected_salary : {required:'This field is required'},
              profile_industry_id: {required:'This field is required'}
  		},
  		submitHandler: function() {
  	        //using default submit function below
  	        return false;
          }
  	});

  	$("#form_jobseeker_intro").on('submit', function(){

        if ($('#form_jobseeker_intro').valid()) {

        	var submitBtn = $(this).parent().next().find('label');
        	submitBtn.button("loading");

          var profile_industry_id = $("#profile_industry_id").val();
          var name = $("#name").val();


          var personal_description = $("#personal_description_basicinfo").val();
  		    var expected_salary_curr = $("#jobseeker_expected_salary_currency").val();
          var expected_salary = $("#jobseeker_expected_salary").val();

          $.post(canvas_url + "api/jobseeker/updateaboutme", {'industry_id': profile_industry_id,'name':name,'personal_description':personal_description,'expected_salary_curr':expected_salary_curr,'expected_salary':expected_salary,'_token': $('meta[name="csrf-token"]').attr('content'), '_method': "POST"}, function (data) {

              if (data.status == 'success')
              {
                submitBtn.button("reset"); //reset button loading
                  $('.modal').modal('hide'); // close active modal


                  var payload =  {
                      'NAME': name,
                      'INDUSTRY':profile_industry_id,
                      'EXPECTEDSALARY':expected_salary,
                  };
                  $.netcoreTracking(NC_ACTIVITY_UPDATE_PROFILE_INTRO, payload, true);

                //alert success
                swal({
                    title: "Success",
                    //text: "You basic intro has been updated",
                    text: checkCompleteness(data.user_profile_completeness),
                    type: "success"
                }).catch(swal.noop);

                setTimeout(function () {
                    window.location = canvas_url + "jobseeker/profile";
                }, timeout_redirect);

              }
              else
              {

                  var text_message = '';
                  for (i = 0; i < data.msg.length; i++) {
                      if (data.msg[i]) {
                          text_message += data.msg[i];
                      }
                  }

                  submitBtn.button("reset");
                  $.notify(text_message, {type: 'danger'});
              }

          }, "json")
          .fail( function(xhr, textStatus, errorThrown) {
              showErrorNotification(xhr.status)
          });

        }
    });

    $("#name").bind('keypress', function (event) {
        var regex = new RegExp("^[a-zA-Z-., ]*$");
        var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
        if (!regex.test(key)) {
            event.preventDefault();
            return false;
        }
    });


    $(".currentlyworkingcheckbox").bind("click", function () {
  		var id = $(this).attr('data-id');
  		if (id==0 || id=='0')
  		{
  			var current_working = $("#currently_working").is(':checked');
  			if (current_working === true)
  			{
  				$("#ae_end_date-div").fadeOut();
  			} else
  			{
  				$("#ae_end_date-div").fadeIn();
  			}
  		}
  		else
  		{
  			var current_working = $("#currently_working-"+id).is(':checked');
  			if (current_working === true)
  			{
  				$("#ae_end_date-div-"+id).fadeOut();
  			} else
  			{
  				$("#ae_end_date-div-"+id).fadeIn();
  			}
  		}
    });

    $(".currentlystudingcheckbox").bind("click", function () {
      var id = $(this).attr('data-id');
  		if (id==0 || id=='0')
  		{
  			var current_education = $("#currently_studing").is(':checked');
  			if (current_education === true)
  			{
  				$("#aedu_end_date-div").fadeOut();
  			} else
  			{
  				$("#aedu_end_date-div").fadeIn();
  			}
  		}
  		else
  		{
  			var current_education = $("#currently_studing-"+id).is(':checked');
  			if (current_education === true)
  			{
  				$("#aedu_end_date-div-"+id).fadeOut();
  			} else
  			{
  				$("#aedu_end_date-div-"+id).fadeIn();
  			}
  		}
    });


    //----------jobseeker info --------------//
    $("#form_jobseeker_info").bind("click", function () {

      $.validator.setDefaults( {
        submitHandler: function () {
          alert( "submitted!" );
        }
      });

      $( "#form_jobseeker_info" ).validate({
        rules: {
          country: {required:true},
          city: {required:true},
          base_country: {required:true},
          address1: {required:true},
          new_state_id: {required:true},
          Other_state:{required:true},
          work_permit:{required:true},
          jobseeker_marital_status : {required:true},
          jobseeker_gender:{required:true},
          postal_code : {required:true,digits:true}

        },
        messages: {
          'address1': 'Please enter Address 1',
          'city': 'Please enter City',
          'country': 'Please select country',
  	    'new_state_id': 'Please select state',
          'work_permit': 'Please work permit',
          Other_state:{
              required:'Please enter your state'
          },
          jobseeker_marital_status : {
            required:'Please choose your status',
          },
          jobseeker_gender:{
            required:'Please choose your gender',
          },
          postal_code:{
            required:'Please enter postal code',
            digits:'Please enter valid postal code'
          }
        },
        submitHandler: function() {

         var gender = $("input[name='jobseeker_gender']:checked").val();
         var dob = $("#jobseeker_dob").val();
         var marital_status = $("input[name='jobseeker_marital_status']:checked").val();
         var nationality = $("#nationality option:selected").text();
         var base_country = $("#base_country").val();
         var work_permit = $("#work_permit").val();
         var id_number = $("#id_number").val();
         var address1 = $("#address1").val();
         var address2 = $("#address2").val();
         var city = $("#city").val();
         var postal_code = $("#postal_code").val();
         var country = $("#country").val();
         var state = '';
         if (country == 'Other'){
         var state = $("#Other_state").val();}
         else{
         var state = $("#new_state_id").val();}
         var submitBtn = $(".submit_basicinfo");

          submitBtn.button("loading");
          $.post(canvas_url + "api/jobseeker/field", {'gender': gender, 'dob': dob, 'marital_status': marital_status,'work_permit': work_permit, 'id_number': id_number,'base_country':base_country,'address1': address1, 'address2': address2, 'city': city, 'postcode': postal_code,'country': country, 'state': state, 'section': '2', '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "POST"}, function (data) {
                if (data.status == 'success') {

                    submitBtn.button("reset"); //reset button loading
                    $('.modal').modal('hide'); // close active modal
                    swal({
                        title: "Success",
                        //text: "You basic information has been updated",
                        text: checkCompleteness(data.user_profile_completeness),
                        type: "success"
                    }).catch(swal.noop);


                    var payload =  {
                        'GENDER': gender,
                        'DOB':dob,
                        'POSTALCODE':postal_code,
                        'CITY':city,
                        'STATE':state,
                        'COUNTRY':country,
                    };
                    $.netcoreTracking(NC_ACTIVITY_UPDATE_BASIC_INFO, payload, true);


                    setTimeout(function () {
                        window.location = canvas_url + "jobseeker/profile";
                    }, timeout_redirect);
                } else {
                    var text_message = '';
                    for (i = 0; i < data.msg.length; i++) {
                        if (data.msg[i]) {
                            text_message += data.msg[i];
                        }
                    }

                    $.notify(text_message, {type: 'danger'});
                    submitBtn.button('reset');
                    submitBtn.closest('.profile-wrap').find('.profile-body').removeClass('load');
                }
            }, "json")
              .fail( function(xhr, textStatus, errorThrown) {
                  showErrorNotification(xhr.status)
              });
          }
      }).form();
    });

  	//check nationality
  	$('#jobseeker_nationality').change(function(){
  	    if($('#jobseeker_nationality').val() == 'Malaysia'){
  	        $('#jobseeker_malaysian').show();
  	        $('#jobseeker_non_malaysian').hide();
  	        $('#jobseeker_non_malaysian').find('.form-group').removeClass('has-error'); //remove error class
  	        $('#jobseeker_non_malaysian').find('.help-block').remove(); //remove error text
  	        $('#jobseeker_non_malaysian').find("input,textarea,select").val(''); //clear input
  	    } else {
  	        $('#jobseeker_non_malaysian').show();
  	        $('#jobseeker_malaysian').hide();
  	        $('#jobseeker_malaysian').find('.form-group').removeClass('has-error'); //remove error class
  	        $('#jobseeker_malaysian').find('.help-block').remove(); //remove error text
  	        $('#jobseeker_malaysian').find("input,textarea,select").val(''); //clear input
  		  }
  	});


    //----------jobseeker experience --------------//
    $(".saveexp").bind("click", function () {

        $.validator.setDefaults( {
          submitHandler: function () {
            alert( "submitted!" );
          }
        });

        $( "#form_jobseeker_experience" ).validate( {
          rules: {
            ae_title: {required:true},
            ae_company_name: {required:true},
            ae_salary:{required:true},
            ae_start_date: {required:true},
            ae_job_description: {required:true},
            category_id: {required:true}
          },
          messages: {
            'ae_title': 'Please enter job title/position',
            'ae_company_name': 'Please enter Company name',
            'ae_salary': 'Please enter salary amount',
            'ae_start_date': 'Please select job start date',
            'ae_end_date': 'Please select job end date',
            'ae_job_description': 'Please enter job description',
            'category_id': 'Please choose Industry',
          },
          submitHandler: function() {

           var current_working = $("#currently_working").is(':checked');
           var ae_company_name = $("#ae_company_name").val();
           var ae_title = $("#ae_title").val();
           var ae_salary_cur = $("#ae_salary_cur").val();
           var ae_salary = $("#ae_salary").val();
           var ae_start_date = $("#ae_start_date").val();
           var ae_end_date = $("#ae_end_date").val();
           var ae_job_description = $("#ae_job_description").val();
           var category_id = $("#category_id").val();


           if (ae_start_date == '')
           {
               $("#ae_start_date").focus();
               $("#ae_start_date").parents('.form-group').addClass("has-error");
               $.notify('Please select Start Date', {type: 'danger'});
               return false;
           }

           if (current_working)
           {

           }
           else if (ae_end_date=='')
           {
               $("#ae_end_date").focus();
               $("#ae_end_date").parents('.form-group').addClass("has-error");
               $.notify('Please select End Date', {type: 'danger'});
               return false;
           }


           var submitBtn = $(".saveexp");
              submitBtn.button("loading");

            $.post(canvas_url + "api/jobseeker/experience", {'company_name': ae_company_name, 'title': ae_title, 'salary_cur': ae_salary_cur, 'salary': ae_salary, 'start_date': ae_start_date, 'end_date': ae_end_date, 'current_working': current_working, 'job_description': ae_job_description, 'category_id': category_id, '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "POST"}, function (data) {
                  if (data.status == 'success') {

                      submitBtn.button("reset"); //reset button loading
                      $('.modal').modal('hide'); // close active modal
                      swal({
                        title: "Success",
                        //text: txt_exp_status_updated,
                        text: checkCompleteness(data.user_profile_completeness),
                        type: "success"
                      }).catch(swal.noop);;


                      var payload =  {
                          'STATUS': current_working,
                          'TITLE':ae_title,
                          'COMPANYNAME':ae_company_name,
                          'FROM1':ae_start_date,
                      };
                      $.netcoreTracking(NC_ACTIVITY_UPDATE_EXPERIENCE, payload, true);

                      setTimeout(function () {
                          window.location = canvas_url + "jobseeker/profile";
                      }, timeout_redirect);
                  } else {
                      var text_message = '';
                      for (i = 0; i < data.msg.length; i++) {
                          if (data.msg[i]) {
                              text_message += data.msg[i];
                          }
                      }
                      $.notify(text_message, {type: 'danger'});
                      submitBtn.button('reset');
                      submitBtn.closest('.profile-wrap').find('.profile-body').removeClass('load');
                  }
              }, "json")
                .fail( function(xhr, textStatus, errorThrown) {
                    submitBtn.button('reset');
                    showErrorNotification(xhr.status)
                });
            }
        }).form();
    });

    $(".updateexp").bind("click", function () {

        $.validator.setDefaults( {
          submitHandler: function () {
            alert( "submitted!" );
          }
        });

        var id = $(this).attr('data-id');
        var rec_id = $(this).attr("data-rec-id");


        $( "#form_jobseeker_experience-"+id ).validate( {
          messages: {
            'ae_title': 'Please enter job title/position',
            'ae_company_name': 'Please enter Company name',
            'ae_salary': 'Please enter salary amount',
            'ae_start_date': 'Please select job start date',
            'ae_job_description': 'Please enter job description',
            'category_id': 'Please choose Industry',
          },
          submitHandler: function() {

           var current_working = $("#currently_working-"+id).is(':checked');
           var ae_company_name = $("#ae_company_name-"+id).val();
           var ae_title = $("#ae_title-"+id).val();
           var ae_salary_cur = $("#ae_salary_cur-"+id).val();
           var ae_salary = $("#ae_salary-"+id).val();
           var ae_start_date = $("#ae_start_date-"+id).val();
           var ae_end_date = $("#ae_end_date-"+id).val();
           var ae_job_description = $("#ae_job_description-"+id).val();
           var category_id = $("#category_id-"+id).val();



          if (ae_start_date == '')
          {
              $("#ae_start_date-" + id).focus();
              $("#ae_start_date-" + id).parents('.form-group').addClass("has-error");
              $.notify('Please select Start Date', {type: 'danger'});
              return false;
          }

  		 if (current_working)
  		 {
  		 }
  		 else if (ae_end_date=='')
  		 {
  			 $("#ae_end_date-"+id).focus();
  			 $("#ae_end_date-"+id).parents('.form-group').addClass("has-error");
  			 $.notify('Please select End Date', {type: 'danger'});
  			 return false;
  		 }

           var submitBtn = $(".updateexp");
              submitBtn.button("loading");

            $.post(canvas_url + "api/jobseeker/experience", {'id':rec_id,'company_name': ae_company_name, 'title': ae_title, 'salary_cur': ae_salary_cur, 'salary': ae_salary, 'start_date': ae_start_date, 'end_date': ae_end_date, 'current_working': current_working, 'job_description': ae_job_description, 'category_id': category_id, '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "PUT"}, function (data) {
                  if (data.status == 'success') {

                      submitBtn.button("reset"); //reset button loading
                      $('.modal').modal('hide'); // close active modal
                      swal({
                        title: "Success",
                        //text: txt_exp_status_updated,
                        text: checkCompleteness(data.user_profile_completeness),
                        type: "success"
                      }).catch(swal.noop);

                      var payload =  {
                          'STATUS': current_working,
                          'TITLE':ae_title,
                          'COMPANYNAME':ae_company_name,
                          'FROM1':ae_start_date,
                      };
                      $.netcoreTracking(NC_ACTIVITY_UPDATE_EXPERIENCE, payload, true);

                      setTimeout(function () {
                          window.location = canvas_url + "jobseeker/profile";
                      }, timeout_redirect);
                  } else {

                      var text_message = '';
                      for (i = 0; i < data.msg.length; i++) {
                          if (data.msg[i]) {
                              text_message += data.msg[i];
                          }
                      }
                      $.notify(text_message, {type: 'danger'});
                      submitBtn.button('reset');
                      submitBtn.closest('.profile-wrap').find('.profile-body').removeClass('load');
                  }
              }, "json")
                .fail( function(xhr, textStatus, errorThrown) {
                    submitBtn.button('reset');
                    showErrorNotification(xhr.status)
                });
            }
        }).form();
    });

    $(".delexp").bind("click", function () {
          var id = $(this).attr('data-id');
          var rec_id = $(this).attr('data-rec-id');
          var $btn = $(this);
          var load = $(this).parents('.profile-wrap');
          swal({
            title: txt_are_u_sure,
            text: txt_remove_experience,
            type: 'warning',
            confirmButtonText: txt_confirm_delete,
            showCancelButton: true,
          }).then(function () {

                $('.modal').modal('hide'); //hide modal
                var jsonData = {
                    '_token': $('meta[name="csrf-token"]').attr('content'),
                    '_method': "DELETE"
                };

                var request = $.ajax({
                    url: canvas_url + "api/jobseeker/experience/" + rec_id,
                    data: jsonData,
                    type: 'DELETE',
                    crossDomain: true,
                    dataType: 'json'
                });

                load.addClass('loading');
                request.done(function (data) {
                  if (data.status == 'success') {

                      swal({
                          title: "Success",
                          //text: txt_experience_deleted,
                          text: checkCompleteness(data.user_profile_completeness),
                          type: "success"
                      }).catch(swal.noop);
                      sendSCLoginEvent(SC_PROFILE,SC_EXPERIENCE_CONFIRMATION_REMOVE, ACTION_CLICK);

                      load.removeClass('loading');
                      $("#jobseeker_experience-" + id).remove();
                      if ( $('#experience-content').children().length < 1 ) {
                           $('#experience-content').remove();
                           $('#section_experience').append('<p class="text-grey">'+txt_no_experience+'</p>');
                      }

                      setTimeout(function () {
                          window.location = canvas_url + "jobseeker/profile";
                      }, timeout_redirect);

                    } else {
                        load.removeClass('loading');
                    }
                });

                request.fail(function (xhr, textStatus) {
                    //$btn.button('reset');
                    load.removeClass('loading');
                    showErrorNotification(xhr.status)
                });
          }).catch(swal.noop);
    });

    //----------jobseeker education --------------//
    $(".saveedu").bind("click", function () {

        $.validator.setDefaults( {
          submitHandler: function () {
            alert( "submitted!" );
          }
        });

        $( "#form_jobseeker_education" ).validate( {
          rules: {
            ae_school_name: {required:true},
            ae_degree: {required:true},
            ae_grade:{required:true},
            ae_major: {required:true},
            aedu_start_date: {required:true}
          },
          messages: {
            'ae_school_name': 'Please enter school',
            'ae_degree': 'Please enter Degree',
            'ae_grade': 'Please enter Grade',
            'ae_major': 'Please enter Major',
            'aedu_start_date': 'Please select Start Date',
  		  'aedu_end_date': 'Please select End Date',
          },
          submitHandler: function() {

              var currently_studing = $("#currently_studing").is(':checked');
              var ae_school_name = $('#school_name_autocomplete').val();
              var ae_degree = $("#ae_degree").val();
              var ae_grade = $("#ae_grade").val();
              var aedu_start_date = $("#aedu_start_date").val();
              var aedu_end_date = $("#aedu_end_date").val();
              var ae_major = $("#ae_major").val();

              if (aedu_start_date == '')
              {
                  $("#aedu_start_date").focus();
                  $("#aedu_start_date").parents('.form-group').addClass("has-error");
                  $.notify('Please select Start Date', {type: 'danger'});
                  return false;
              }

              if (currently_studing)
              {

              }
              else if (aedu_end_date=='')
              {
                  $("#aedu_end_date").focus();
                  $("#aedu_end_date").parents('.form-group').addClass("has-error");
                  $.notify('Please select End Date', {type: 'danger'});
                    return false;
              }

           var submitBtn = $(".saveedu");
              submitBtn.button("loading");

            $.post(canvas_url + "api/jobseeker/education", {
                'school_name': ae_school_name,
                'degree': ae_degree,
                'grade': ae_grade,
                'start_date': aedu_start_date,
                'end_date': aedu_end_date,
                'currently_studing': currently_studing,
                'description': ae_major,
                '_token': $('meta[name="csrf-token"]').attr('content'),
                '_method': "POST"
            }, function (data) {
                  if (data.status == 'success') {

                      submitBtn.button("reset"); //reset button loading
                      $('.modal').modal('hide'); // close active modal


                      swal({
                          title: "Success",
                          //text: txt_education_updated,
                          text: checkCompleteness(data.user_profile_completeness),
                          type: "success"
                      }).catch(swal.noop);

                      var payload =  {
                          'QUALIFICATION': ae_degree,
                          'MAJOR':ae_major,
                      };
                      $.netcoreTracking(NC_ACTIVITY_UPDATE_EDUCATION, payload, true);


                      setTimeout(function () {
                          window.location = canvas_url + "jobseeker/profile";
                      }, timeout_redirect);
                  } else {
                      var text_message = '';
                      for (i = 0; i < data.msg.length; i++) {
                          if (data.msg[i]) {
                              text_message += data.msg[i];
                          }
                      }
                      $.notify(text_message, {type: 'danger'});
                      submitBtn.button('reset');
                      submitBtn.closest('.profile-wrap').find('.profile-body').removeClass('load');
                  }
              }, "json")
                .fail( function(xhr, textStatus, errorThrown) {
                    submitBtn.button('reset');
                    showErrorNotification(xhr.status)
            });
            }
        }).form();
    });

    $(".updateedu").bind("click", function () {

        $.validator.setDefaults( {
          submitHandler: function () {
            alert( "submitted!" );
          }
        });

        var id = $(this).attr('data-id');
        var rec_id = $(this).attr("data-rec-id");

        $( "#form_jobseeker_education-"+id ).validate( {
          messages: {
            'ae_school_name': 'Please enter school',
            'ae_degree': 'Please enter Degree',
            'ae_grade': 'Please enter Grade',
            'ae_major': 'Please enter Major',
            'aedu_start_date': 'Please select Start Date',
  		  'aedu_end_date': 'Please select End Date',
          },
          submitHandler: function() {

           var currently_studing = $("#currently_studing-" + id).is(':checked');
           var ae_school_name = $("#ae_school_name-edit-" + id).val();
           var ae_degree = $("#ae_degree-" + id).val();
           var ae_grade = $("#ae_grade-" + id).val();
           var aedu_start_date = $("#aedu_start_date-" + id).val();
           var aedu_end_date = $("#aedu_end_date-" + id).val();
           var ae_major = $("#ae_major-" + id).val();

          if (aedu_start_date == '')
          {
              $("#aedu_start_date-"+id).focus();
              $("#aedu_start_date-"+id).parents('.form-group').addClass("has-error");
              $.notify('Please select Start Date', {type: 'danger'});
              return false;
          }

  		 if (currently_studing)
  		 {
  		 }
  		 else if (aedu_end_date=='')
  		 {
  			 $("#aedu_end_date-" + id).focus();
  			 $("#aedu_end_date-" + id).parents('.form-group').addClass("has-error");
  			 $.notify('Please select End Date', {type: 'danger'});
  			 return false;
  		 }

           var submitBtn = $(".updateedu");
              submitBtn.button("loading");

            var jsonData = {
                'id':rec_id,
                'school_name': ae_school_name,
                'degree': ae_degree,
                'grade': ae_grade,
                'start_date': aedu_start_date,
                'end_date': aedu_end_date,
                'currently_studing': currently_studing,
                'description': ae_major,
                '_token': $('meta[name="csrf-token"]').attr('content'),
                '_method': "PUT",
            };
            var request = $.ajax({
                url: canvas_url + "api/jobseeker/education",
                type: 'PUT',
                data: jsonData,
                dataType: 'json'
            });
            request.done(function(data) {
                  if (data.status == 'success') {

                      submitBtn.button("reset"); //reset button loading
                      $('.modal').modal('hide'); // close active modal

                      swal({
                          title: "Success",
                          //text: txt_education_updated,
                          text: checkCompleteness(data.user_profile_completeness),
                          type: "success"
                      }).catch(swal.noop);


                      var payload =  {
                          'QUALIFICATION': ae_degree,
                          'MAJOR':ae_major,
                      };
                      $.netcoreTracking(NC_ACTIVITY_UPDATE_EDUCATION, payload, true);


                      setTimeout(function () {
                          window.location = canvas_url + "jobseeker/profile";
                      }, timeout_redirect);
                  } else {
                      var text_message = '';
                      for (i = 0; i < data.msg.length; i++) {
                          if (data.msg[i]) {
                              text_message += data.msg[i];
                          }
                      }
                      //swal("Opps!", text_message, "warning");
                      $.notify(text_message, {type: 'danger'});
                      submitBtn.button('reset');
                      submitBtn.closest('.profile-wrap').find('.profile-body').removeClass('load');
                  }
              });
            request.fail( function(xhr, textStatus, errorThrown) {
                showErrorNotification(xhr.status)
            });
            }
        }).form();
    });

    $(".deledu").bind("click", function () {
          var id = $(this).attr('data-id');
          var rec_id = $(this).attr('data-rec-id');
          var $btn = $(this);
          var load = $(this).parents('.profile-wrap');

          swal({
            title: txt_are_u_sure,
            text: txt_remove_edu,
            type: 'warning',
            confirmButtonText: txt_confirm_delete,
            showCancelButton: true,
          }).then(function () {

                $('.modal').modal('hide'); //hide modal

                var jsonData = {
                    '_token': $('meta[name="csrf-token"]').attr('content'),
                    '_method': "DELETE"
                };
                var request = $.ajax({
                    url: canvas_url + "api/jobseeker/education/" + rec_id,
                    data: jsonData,
                    type: 'DELETE',
                    crossDomain: true,
                    dataType: 'json'
                });
                //$btn.button("loading");
                load.addClass('loading');
                request.done(function (data) {
                  if (data.status == 'success') {

                      swal({
                          title: "Success",
                          //text: txt_education_deleted,
  						text: checkCompleteness(data.user_profile_completeness),
                          type: "success"
                      }).catch(swal.noop);
                      sendSCLoginEvent(SC_PROFILE,SC_EDUCATION_CONFIRMATION_REMOVE, ACTION_CLICK);

                      load.removeClass('loading');
                      $("#jobseeker_education-" + id).remove();
                      if ( $('#education-content').children().length < 1 ) {
                           $('#education-content').remove();
                           $('#section_education').append('<p class=" text-grey">'+txt_no_edu+'</p>');
                      }

                      setTimeout(function () {
                          window.location = canvas_url + "jobseeker/profile";
                      }, timeout_redirect);
                    } else {
                        load.removeClass('loading');
                    }
                });

                request.fail(function (jqXHR, textStatus) {
                    load.removeClass('loading');
                    showErrorNotification(jqXHR.status)
                });

          }).catch(swal.noop);;
    });


    //----------jobseeker lang --------------//
    $('#form_jobseeker_lang').validate({
    	rules: {
    		language1 : {required:true},
        language2 : {required:true},
        language3 : {required:true},
    		otherlanguage : {required:true}
    	},
    	messages: {
    		language1 : {required : 'This field is required'},
        language2 : {required : 'This field is required'},
        language3 : {required : 'This field is required'},
    		otherlanguage : {required : 'This field is required'}
    	},
  	  submitHandler: function() {
          //using default submit function below
          return false;
        }
    });

    $('#form_jobseeker_lang').on('submit', function(){
    	if($('#form_jobseeker_lang').valid()) {


          var language1 = 'English';
          var language_rate1 = $("input[name=language1]:checked").val();
          var language2 = 'Bahasa Malaysia';
          var language_rate2 = $("input[name=language2]:checked").val();
          var language3 = 'Chinese';
          var language_rate3 = $("input[name=language3]:checked").val();
          var language4 = 'Bahasa Indonesia';
          var language_rate4 = $("input[name=language4]:checked").val();
          var otherlanguage = 'Tamil';
          var otherlanguage_rate = $("input[name=otherlanguage]:checked").val();

          var submitBtn = $(this).parent().next().find('label');
        	submitBtn.button("loading");

          $.post(canvas_url + "api/jobseeker/skills", {'type': 'language', 'language1': language1, 'language_rate1': language_rate1, 'language2': language2, 'language_rate2': language_rate2, 'language3': language3, 'language_rate3': language_rate3, 'language4': language4, 'language_rate4': language_rate4, 'otherlanguage': otherlanguage, 'otherlanguage_rate': otherlanguage_rate, '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "POST"}, function (data) {

              submitBtn.button("reset"); //reset button loading
              $('.modal').modal('hide'); // close active modal

              if (data.status == 'success') {

                  swal({
                      title: "Success",
                      //text: 'You language has been updated',
                      text: checkCompleteness(data.user_profile_completeness),
                      type: "success"
                  }).catch(swal.noop);

                  var payload =  {
                      'ENGLISH': $("input[name=language1]:checked").attr('data-txt'),
                      'MALAY':$("input[name=language2]:checked").attr('data-txt'),
                      'MANDARIN':$("input[name=language3]:checked").attr('data-txt'),
                      'TAMIL':$("input[name=otherlanguage]:checked").attr('data-txt'),
                  };
                  $.netcoreTracking(NC_ACTIVITY_UPDATE_LANGUAGE, payload, true);


                  setTimeout(function () {
                      window.location = canvas_url + "jobseeker/profile";
                  }, timeout_redirect);

              } else {
                  $.notify(data.msg, {type: 'danger'});
                  submitBtn.button('reset');
                  submitBtn.closest('.profile-wrap').find('.profile-body').removeClass('load');
              }
          }, "json")
          .fail( function(xhr, textStatus, errorThrown) {
              submitBtn.button("reset");
              showErrorNotification(xhr.status)
          });
    	}
    });


    //----------jobseeker skill --------------//

    $('#form_jobseeker_skill-profile').validate();

    $('#form_jobseeker_skill-profile').on('submit', function(event){

        // prevent default submit action
        event.preventDefault();


        $('input.jobseeker_skills').each(function() {
            $(this).rules("add",
                {
                    required: true,
                    normalizer: function(value) {
                        return $.trim(value);
                    }
                })
        });


        if($('#form_jobseeker_skill-profile').valid()) {
          var jobseeker_skills = $(".jobseeker_skills").map(function () {
              return $(this).val();
          }).get();
          var jobseeker_skill_levels = $(".jobseeker_skill_levels").map(function () {
              return $(this).val();
          }).get();

          var submitBtn = $(this).parent().next().find('label');
        	submitBtn.button("loading");

          $.post(canvas_url + "api/jobseeker/skills", {'type': 'skills', 'skills': jobseeker_skills, 'skill_levels': jobseeker_skill_levels, '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "POST"}, function (data) {

              submitBtn.button("reset");
              $('.modal').modal('hide');

              if (data.status == 'success') {
                    sendSCLoginEvent(SC_PROFILE,SC_SKILLS_SUBMIT_SUCCESS,ACTION_CLICK)

                  swal({
                      title: "Success",
                      text: checkCompleteness(data.user_profile_completeness),
                      type: "success"
                  }).catch(swal.noop);

                  setTimeout(function () {
                      window.location = canvas_url + "jobseeker/profile";
                  }, timeout_redirect);

              } else {
                  sendSCLoginEvent(SC_PROFILE,SC_SKILLS_SUBMIT_FAILED, ACTION_CLICK);

                  $.notify(data.msg, {type : 'danger'});
                  submitBtn.button('reset');
                  submitBtn.closest('.profile-wrap').find('.profile-body').removeClass('load');
              }
          }, "json")
          .fail( function(xhr, textStatus, errorThrown) {
              submitBtn.button('reset');
              showErrorNotification(xhr.status)
          });

    	}
    });


    //----------jobseeker activities --------------//

    $(".saveactivity").bind("click", function () {

        $.validator.setDefaults( {
          submitHandler: function () {
            alert( "submitted!" );
          }
        });

        $( "#form_jobseeker_activities" ).validate( {
          rules: {
            add_activity_year: {required:true},
            add_activity_activity: {required:true}
          },
          messages: {
            'add_activity_year': 'Please enter year',
            'add_activity_activity': 'Please enter activity'
          },
          submitHandler: function() {

           var add_activity_year = $("#add_activity_year").val();
           var add_activity_activity = $("#add_activity_activity").val().trim();
           var activity = {};

           if (add_activity_year == '')
           {
               $("#add_activity_year").focus();
               $("#add_activity_year").parents('.form-group').addClass("has-error");
               $.notify('Please enter year', {type: 'danger'});
               return false;
           }

           if (add_activity_activity=='')
           {
               $.notify('Please enter activity', {type: 'danger'});
               return false;
           }

           activity.action = 'add';
           activity.date = add_activity_year;
           activity.description = add_activity_activity;

           var submitBtn = $(".saveactivity");
              submitBtn.button("loading");

            $.post(canvas_url + "api/jobseeker/field", {'activity': activity, '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "POST"}, function (data) {
                  if (data.status == 'success') {

                      submitBtn.button("reset"); //reset button loading
                      $('.modal').modal('hide'); // close active modal

                      swal({
                          title: "Success",
                          //text: 'Activity has been added successfully',
                          text: checkCompleteness(data.user_profile_completeness),
                          type: "success"
                      }).catch(swal.noop);


                      setTimeout(function () {
                          window.location = canvas_url + "jobseeker/profile";
                      }, timeout_redirect);
                  } else {
                      var text_message = '';
                      for (i = 0; i < data.msg.length; i++) {
                          if (data.msg[i]) {
                              text_message += data.msg[i];
                          }
                      }
                      //swal("Opps!", text_message, "warning");
                      $.notify(text_message, {type: 'danger'});
                      submitBtn.button('reset');
                      submitBtn.closest('.profile-wrap').find('.profile-body').removeClass('load');
                  }
              }, "json")
                .fail( function(xhr, textStatus, errorThrown) {
                    submitBtn.button('reset');
                    showErrorNotification(xhr.status)
                });
            }
        }).form();
    });

    $(".updateactivity").bind("click", function () {

        $.validator.setDefaults( {
          submitHandler: function () {
            alert( "submitted!" );
          }
        });

        var id = $(this).attr('data-id');
        var rec_id = $(this).attr("data-rec-id");

        $( "#form_jobseeker_activities-"+id ).validate( {
          messages: {
            'add_activity_year': 'Please enter year',
            'add_activity_activity': 'Please enter activity'
          },
          submitHandler: function() {

           var add_activity_year = $("#add_activity_year-"+id).val();
           var add_activity_activity = $("#add_activity_activity-"+id).val().trim();
           var activity = {};

           if (add_activity_year == '' || add_activity_year <= 0)
           {
               $("#add_activity_year-"+id).focus();
               $("#add_activity_year-"+id).parents('.form-group').addClass("has-error");
               $.notify('Please enter year.', {type: 'danger'});
              return false;
           }

           if (add_activity_activity=='')
           {
              $.notify('Please enter activity.', {type: 'danger'});
              return false;
           }

           activity.action = 'edit';
           activity.id = rec_id;
           activity.date = add_activity_year;
           activity.description = add_activity_activity;

           var submitBtn = $(".updateactivity");
              submitBtn.button("loading");

            $.post(canvas_url + "api/jobseeker/field", {'activity': activity, '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "POST"}, function (data) {
                  if (data.status == 'success') {

                      submitBtn.button("reset"); //reset button loading
                      $('.modal').modal('hide'); // close active modal


                      swal({
                          title: "Success",
                          //text: 'Activity has been updated successfully',
                          text: checkCompleteness(data.user_profile_completeness),
                          type: "success"
                      }).catch(swal.noop);


                      setTimeout(function () {
                          window.location = canvas_url + "jobseeker/profile";
                      }, timeout_redirect);
                  } else {
                      var text_message = '';
                      for (i = 0; i < data.msg.length; i++) {
                          if (data.msg[i]) {
                              text_message += data.msg[i];
                          }
                      }

                      $.notify(text_message, {type: 'danger'});
                      submitBtn.button('reset');
                      submitBtn.closest('.profile-wrap').find('.profile-body').removeClass('load');
                  }
              }, "json")
                .fail( function(xhr, textStatus, errorThrown) {
                    submitBtn.button('reset');
                    showErrorNotification(xhr.status)
                });
            }
        }).form();
    });

    $(".delactivity").bind("click", function () {
          var id = $(this).attr('data-id');
          var rec_id = $(this).attr('data-rec-id');
          var load= $(this).parents('.profile-wrap')

          var activity = {};

           activity.action = 'delete';
           activity.id = rec_id;

          swal({
            title: txt_are_u_sure,
            text: 'You want to remove this activity?',
            type: 'warning',
            width: 450,
            showCancelButton: true,
            confirmButtonText: txt_confirm_delete,
          }).then(function () {

              $('.modal').modal('hide'); //hide modal
              load.addClass('loading');
              $.post(canvas_url + "api/jobseeker/field", {'activity': activity, '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "POST"}, function (data) {
                  if (data.status == 'success') {


                      swal({
                          title: "Success",
                         // text: 'Activity deleted successfully',
  						text: checkCompleteness(data.user_profile_completeness),
                          type: "success"
                      }).catch(swal.noop);
                      sendSCLoginEvent(SC_PROFILE,SC_AWARD_CONFIRMATION_REMOVE, ACTION_CLICK);

                      load.removeClass('loading');
                      $("#jobseeker_activities-" + id).remove();
                      if ( $('#activities-content').children().length < 1 ) {
                           $('#activities-content').remove();
                           $('#section_activities').append('<p class=" text-grey">No activities found. Please add your activity</p>');
                      }

                      setTimeout(function () {
                          window.location = canvas_url + "jobseeker/profile";
                      }, timeout_redirect);

                  } else {
                      load.removeClass('loading');
                      var text_message = '';
                      for (i = 0; i < data.msg.length; i++) {
                          if (data.msg[i]) {
                              text_message += data.msg[i];
                          }
                      }
                      $.notify(text_message, {type: 'danger'});
                  }
              }, "json")
              .fail( function(xhr, textStatus, errorThrown) {
                  load.removeClass('loading');
                  showErrorNotification(xhr.status)
              });
          }).catch(swal.noop);
    });

    //----------jobseeker references --------------//

    $(".savereference").bind("click", function () {

        $.validator.setDefaults( {
          submitHandler: function () {
            alert( "submitted!" );
          }
        });

        $( "#form_jobseeker_reference" ).validate( {
          rules: {
            jobseeker_reference_name: {required:true},
            jobseeker_reference_position: {required:true},
            jobseeker_reference_company: {required:true},
            jobseeker_reference_relationship: {required:true},
            jobseeker_reference_email : {required:"#jobseeker_reference_contact:blank",email: true},
            jobseeker_reference_contact : {required:"#jobseeker_reference_email:blank"}
          },
          messages: {
            jobseeker_reference_name : {required:'Please enter name'},
            jobseeker_reference_position : {required:'Please enter position'},
            jobseeker_reference_company : {required:'Please enter company name'},
            jobseeker_reference_relationship : {required:'Please enter relationship'},
            jobseeker_reference_email : {required:'Please enter email',email:'Please enter valid email address'},
            jobseeker_reference_contact :  {required:'Please enter contact number'}
          },
          submitHandler: function() {

            var jobseeker_reference_name = $("#jobseeker_reference_name").val();
            var jobseeker_reference_position = $("#jobseeker_reference_position").val();
            var jobseeker_reference_relationship = $("#jobseeker_reference_relationship").val();
            var jobseeker_reference_company = $("#jobseeker_reference_company").val();
            var jobseeker_reference_email = $("#jobseeker_reference_email").val();
            var jobseeker_reference_contact = $("#jobseeker_reference_contact").intlTelInput("getNumber");
            if (jobseeker_reference_contact!='')
            {
              jobseeker_reference_contact = jobseeker_reference_contact.replace('+','');
            }

            var reference = {};
            reference.action = 'add';
            reference.name = jobseeker_reference_name;
            reference.relationship = jobseeker_reference_relationship;
            reference.phone = jobseeker_reference_contact;
            reference.email = jobseeker_reference_email;
            reference.position = jobseeker_reference_position;
            reference.company = jobseeker_reference_company;

            var submitBtn = $(".savereference");
            submitBtn.button("loading");

            $.post(canvas_url + "api/jobseeker/field", {'reference': reference, '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "POST"}, function (data) {
                  if (data.status == 'success') {

                      submitBtn.button("reset"); //reset button loading
                      $('.modal').modal('hide'); // close active modal


                      swal({
                          title: "Success",
                          //text: 'Reference has been added successfully',
                          text: checkCompleteness(data.user_profile_completeness),
                          type: "success"
                      }).catch(swal.noop);


                      setTimeout(function () {
                          window.location = canvas_url + "jobseeker/profile";
                      }, timeout_redirect);
                  } else {
                      var text_message = '';
                      for (i = 0; i < data.msg.length; i++) {
                          if (data.msg[i]) {
                              text_message += data.msg[i];
                          }
                      }
                      //swal("Opps!", text_message, "warning");
                      $.notify(text_message, {type: 'danger'});
                      submitBtn.button('reset');
                      submitBtn.closest('.profile-wrap').find('.profile-body').removeClass('load');
                  }
              }, "json")
                .fail( function(xhr, textStatus, errorThrown) {
                    submitBtn.button('reset');
                    showErrorNotification(xhr.status)
                });
            }
        }).form();
    });

    $(".updatereference").bind("click", function () {

        $.validator.setDefaults( {
          submitHandler: function () {
            alert( "submitted!" );
          }
        });

        var id = $(this).attr('data-id');
        var rec_id = $(this).attr("data-rec-id");

        $( "#form_jobseeker_reference-"+id ).validate( {

          rules: {
            jobseeker_reference_name: {required:true},
            jobseeker_reference_position: {required:true},
            jobseeker_reference_company: {required:true},
            jobseeker_reference_relationship: {required:true},
            jobseeker_reference_email : {required:"#jobseeker_reference_contact-"+id+":blank",email: true},
            jobseeker_reference_contact : {required:"#jobseeker_reference_email-"+id+":blank"}
          },
          messages: {
            jobseeker_reference_name : {required:'Please enter name'},
            jobseeker_reference_position : {required:'Please enter position'},
            jobseeker_reference_company : {required:'Please enter company name'},
            jobseeker_reference_relationship : {required:'Please enter relationship'},
            jobseeker_reference_email : {required:'Please enter email',email:'Please enter valid email address'},
            jobseeker_reference_contact :  {required:'Please enter contact number'}
          },
          submitHandler: function() {

            var jobseeker_reference_name = $("#jobseeker_reference_name-"+id).val();
            var jobseeker_reference_position = $("#jobseeker_reference_position-"+id).val();
            var jobseeker_reference_relationship = $("#jobseeker_reference_relationship-"+id).val();
            var jobseeker_reference_company = $("#jobseeker_reference_company-"+id).val();
            var jobseeker_reference_email = $("#jobseeker_reference_email-"+id).val();
            var jobseeker_reference_contact = $("#jobseeker_reference_contact-"+id).intlTelInput("getNumber");
            if (jobseeker_reference_contact!='')
            {
              jobseeker_reference_contact = jobseeker_reference_contact.replace('+','');
            }
            var reference = {};

            reference.action = 'edit';
            reference.id = rec_id;
            reference.name = jobseeker_reference_name;
            reference.relationship = jobseeker_reference_relationship;
            reference.phone = jobseeker_reference_contact;
            reference.email = jobseeker_reference_email;
            reference.position = jobseeker_reference_position;
            reference.company = jobseeker_reference_company;


            var submitBtn = $(".updatereference");
            submitBtn.button("loading");

            $.post(canvas_url + "api/jobseeker/field", {'reference': reference, '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "POST"}, function (data) {
                  if (data.status == 'success') {

                      submitBtn.button("reset"); //reset button loading
                      $('.modal').modal('hide'); // close active modal

                      swal({
                          title: "Success",
                          //text: 'Reference has been updated successfully',
                          text: checkCompleteness(data.user_profile_completeness),
                          type: "success"
                      }).catch(swal.noop);

                      setTimeout(function () {
                          window.location = canvas_url + "jobseeker/profile";
                      }, timeout_redirect);
                  } else {
                      var text_message = '';
                      for (i = 0; i < data.msg.length; i++) {
                          if (data.msg[i]) {
                              text_message += data.msg[i];
                          }
                      }
                      //swal("Opps!", text_message, "warning");
                      $.notify(text_message, {type: 'danger'});
                      submitBtn.button('reset');
                      submitBtn.closest('.profile-wrap').find('.profile-body').removeClass('load');
                  }
              }, "json")
                .fail( function(xhr, textStatus, errorThrown) {
                    submitBtn.button('reset');
                    showErrorNotification(xhr.status)
                });
            }
        }).form();
    });

    $(".delreference").bind("click", function () {
          var id = $(this).attr('data-id');
          var rec_id = $(this).attr('data-rec-id');
          var load = $(this).parents('.profile-wrap');

          var reference = {};

           reference.action = 'delete';
           reference.id = rec_id;

          swal({
            title: txt_are_u_sure,
            text: 'You want to remove this reference',
            type: 'warning',
            width: 450,
            showCancelButton: true,
            confirmButtonText: txt_confirm_delete,
          }).then(function () {
              $('.modal').modal('hide'); //hide modal
              load.addClass('loading');
              $.post(canvas_url + "api/jobseeker/field", {'reference': reference, '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "POST"}, function (data) {
                  if (data.status == 'success') {

                      //$.notify('Reference deleted successfully!', {type: 'success'});
                      swal({
                          title: "Success",
                          //text: 'Reference deleted successfully',
                          text: checkCompleteness(data.user_profile_completeness),
                          type: "success"
                      }).catch(swal.noop);
                      sendSCLoginEvent(SC_PROFILE,SC_REFERENCES_CONFIRMATION_REMOVE, ACTION_CLICK);

                      load.removeClass('loading');
                      $("#jobseeker_reference-" + id).remove();
                      if ( $('#references-content').children().length < 1 ) {
                           $('#references-content').remove();
                           $('#section_references').find('.btn').hide();
                           $('#section_references').append('\
                            <p class=" text-grey">No references found. Please add your reference</p>');
                      }

                      setTimeout(function () {
                          window.location = canvas_url + "jobseeker/profile";
                      }, timeout_redirect);
                  } else {
                      load.removeClass('loading');
                      var text_message = '';
                      for (i = 0; i < data.msg.length; i++) {
                          if (data.msg[i]) {
                              text_message += data.msg[i];
                          }
                      }
                      $.notify(text_message, {type: 'danger'});
                  }
              }, "json")
              .fail( function(xhr, textStatus, errorThrown) {
                  load.removeClass('loading');
                  showErrorNotification(xhr.status)
              });
          }).catch(swal.noop);
    });


    //-------- jobseeker setting -----//
    $('#form_jobseeker_setting').validate({
      rules:{
        jobseeker_prefered_lang : {required:true},
        /*jobseeker_prefered_time : {required:true},
        jobseeker_prefered_channel : {required:true},
  	  expected_salary : {required:true,digits: true},*/
        availability : {required:true},
        email_alert : {required:true},
        jobseeker_resume_privacy : {required:true}
      },
      messages:{
        jobseeker_prefered_lang : {required:'This field is required'},
        /*jobseeker_prefered_time : {required:'This field is required'},
        jobseeker_prefered_channel : {required:'This field is required'},
  	  expected_salary : {required:'This field is required'},*/
        availability : {required:'This field is required'},
        email_alert : {required:'This field is required'},
        jobseeker_resume_privacy : {required:'This field is required'}
      }
    });

    $('#form_jobseeker_setting').on('submit', function(){
      if($('#form_jobseeker_setting').valid()) {

          var submitBtn = $(this).parent().next().find('label');
          submitBtn.button("loading");

          var desiredposition = "";
          var prefer_locations = '0';
          var prefer_categories = '0';

          var prefer_timings = '';
          var prefer_channel = '';

          var preferTimings = new Array();
          var  i =0;
          $(".jobseeker_prefered_time").each(function (index) {
              if ($(this).is(':checked'))
              {
                preferTimings[i] = $(this).attr("value");
                i++;
              }
          });

          prefer_timings = preferTimings.join();

          var preferChannels = new Array();
          var  i =0;
          $(".jobseeker_prefered_channel").each(function (index) {
              if ($(this).is(':checked'))
              {
                preferChannels[i] = $(this).attr("value");
                i++;
              }
          });
          checkWhatsappOptOut(preferChannels, function (result) {
              console.log(result);
          });
          prefer_channel = preferChannels.join();

          var expected_salary_curr = $("#jobseeker_expected_salary_currency").val();
          var expected_salary = $("#expected_salary").val();
          var userlanguage = $('input[name=jobseeker_prefered_lang]:checked').val();
          var availability = $("#availability").val();
          var email_alert = $('input[name=email_alert]:checked').val();
          var privacy = $('#hide_profile_checkbox').is(':checked') ? "private" : "public";
          var gcm_subscribe = $('input[name=gcm_subscribe]:checked').val();

          $.post(canvas_url + "api/jobseeker/preference", {'userlanguage': userlanguage, 'desiredposition': desiredposition, 'availability': availability, 'prefer_timings': preferTimings, 'prefer_channel': preferChannels, 'prefer_locations': prefer_locations, 'prefer_categories': prefer_categories, 'expected_salary': expected_salary, 'expected_salary_curr': expected_salary_curr, 'email_alert': email_alert, 'privacy': privacy, '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "POST"}, function (data) {

              submitBtn.button("reset"); //reset button loading
              $('.modal').modal('hide'); // close active modal

              if (data.status == 'success') {

                  swal({
                    title: "Success",
                    text: txt_preference_saved,
                    type: "success"
                  }).catch(swal.noop);

                  sendSCLoginEvent(PROFILE_DETAILS,SETTING_PRIVACY_EDITED);

                  setTimeout(function () {
                      window.location = canvas_url + "jobseeker/setting";
                  }, timeout_redirect);
              } else {
                  $.notify(data.msg);
                  submitBtn.closest('.profile-wrap').find('.profile-body').removeClass('load');
              }
          }, "json")
              .fail( function(xhr, textStatus, errorThrown) {
                  submitBtn.button("reset");
                  showErrorNotification(xhr.status)
              });
      }
    });


    var hideProfileCheckbox = $("#hide_profile_checkbox");
    hideProfileCheckbox.bind("click", function () {
      if($(this).is(':checked')){
          swal({
              title: txt_are_u_sure,
              text: txt_hide_profile_desc,
              type: 'warning',
              width: 450,
              showCancelButton: true,
              confirmButtonText: txt_proceed,
          }).then(function(proceed) {
              hideProfileCheckbox.prop('checked', true);
          }, function(dismiss) {
              hideProfileCheckbox.prop('checked', false);
          });
      }
    });
    //------ jobseeker alert ----//
    $(".savealert").bind("click", function () {

        $.validator.setDefaults( {
          submitHandler: function () {
            alert( "submitted!" );
          }
        });

        $( "#form_jobseeker_alert" ).validate( {
          rules: {
            jobseeker_alert_jobtitle : {required: true},
            jobseeker_alert_jobtype : {required:true},
            jobseeker_alert_expected_salary : {required:true},
            jobseeker_alert_industry : {required:true},
            jobseeker_alert_location_country : {required:true},
            jobseeker_alert_location_state : {required:true},
            jobseeker_alert_location_city : {required:true}
          },
          messages: {
            jobseeker_alert_jobtitle : {required: 'This field is required'},
            jobseeker_alert_jobtype : {required:'This field is required'},
            jobseeker_alert_expected_salary : {required:'This field is required'},
            jobseeker_alert_industry : {required:'This field is required'},
            jobseeker_alert_location_country : {required:'This field is required'},
            jobseeker_alert_location_state : {required:'This field is required'},
            jobseeker_alert_location_city : {required:'This field is required'}
          },
          submitHandler: function() {

           var title = 'Job Alert';
           var keywords = $("#jobseeker_alert_jobtitle").val();
           var prefer_locations = $("#jobseeker_alert_location_state_jobalert").val();
           var prefer_categories = $("#jobseeker_alert_industry").val();
           var jobalert_city = $("#jobseeker_alert_location_city").val();
           var jobalert_country = $("#jobseeker_alert_location_country").val();
           var expected_salary_curr = $("#jobseeker_alert_expected_salary_currency").val();
           var expected_salary = $("#jobseeker_alert_expected_salary").val();
           var jobalert_email = $("#new_jobalert_email").val();
           var jobalert_name = $("#new_jobalert_name").val();
           var jobalert_contact = $("#new_jobalert_contact").val();
           var job_type = $("#jobseeker_alert_jobtype").val();
           var alert_status = '';

           var submitBtn = $(".savealert");
              submitBtn.button("loading");

            $.post(canvas_url + "api/jobseeker/save-job-alert", {'title': title, 'keywords': keywords, 'prefer_locations': prefer_locations, 'city': jobalert_city,'country': jobalert_country, 'prefer_categories': prefer_categories, 'expected_salary': expected_salary, 'expected_salary_curr': expected_salary_curr, 'jobalert_email': jobalert_email, 'name': jobalert_name, 'jobalert_contact': jobalert_contact, 'alert_status': alert_status, job_type: job_type, '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "POST"}, function (data) {
                  if (data.status == 'success') {

                      submitBtn.button("reset"); //reset button loading
                      $('.modal').modal('hide'); // close active modal

                      swal({
                        title: "Success",
                        text: txt_job_alert_saved_2,
                        type: "success"
                      }).catch(swal.noop);
                      
                      sendSCLoginEvent(PROFILE_DETAILS,SETTING_ALERT_JOB_ADDED);

                      setTimeout(function () {
                          window.location = canvas_url + "jobseeker/setting";
                      }, timeout_redirect);
                  } else {
                      var text_message = '';
                      for (i = 0; i < data.msg.length; i++) {
                          if (data.msg[i]) {
                              text_message += data.msg[i];
                          }
                      }
                      $.notify(text_message, {type: 'danger'});
                      submitBtn.button('reset');
                      submitBtn.closest('.profile-wrap').find('.profile-body').removeClass('load');
                  }
              }, "json")
                .fail( function(xhr, textStatus, errorThrown) {
                    submitBtn.button('reset');
                    showErrorNotification(xhr.status)
                });
            }
        }).form();
    });

    $(".updatealert").bind("click", function () {

        $.validator.setDefaults( {
          submitHandler: function () {
            alert( "submitted!" );
          }
        });

        var id = $(this).attr('data-id');
        var rec_id = $(this).attr("data-rec-id");
        var rec_type = 'alert';

        $( "#form_jobseeker_alert-"+id ).validate( {
          messages: {
            jobseeker_alert_jobtitle : {required: 'This field is required'},
            jobseeker_alert_jobtype : {required:'This field is required'},
            jobseeker_alert_expected_salary : {required:'This field is required'},
            jobseeker_alert_industry : {required:'This field is required'},
            jobseeker_alert_location_country : {required:'This field is required'},
            jobseeker_alert_location_state : {required:'This field is required'},
            jobseeker_alert_location_other_state : {required:'This field is required'},
            jobseeker_alert_location_city : {required:'This field is required'}
          },
          submitHandler: function() {

           var title = 'Job Alert';
           var keywords = $("#jobseeker_alert_jobtitle-"+id).val();
           var prefer_locations = $("#jobseeker_alert_location_state-jobalert-"+id).val();
           var prefer_categories = $("#jobseeker_alert_industry-"+id).val();
           var jobalert_city = $("#jobseeker_alert_location_city-"+id).val();
           var jobalert_country = $("#jobseeker_alert_location_country-"+id).val();
           var expected_salary_curr = $("#jobseeker_alert_expected_salary_currency-"+id).val();
           var expected_salary = $("#jobseeker_alert_expected_salary-"+id).val();

           var jobalert_email = $("#new_jobalert_email").val();
           var jobalert_name = $("#new_jobalert_name").val();
           var jobalert_contact = $("#new_jobalert_contact").val();
           var job_type = $("#jobseeker_alert_jobtype-"+id).val();
           var alert_status = '';

           var submitBtn = $(".updatealert");
              submitBtn.button("loading");

            $.post(canvas_url + "api/jobseeker/job-alert", {'id': rec_id, 'type': rec_type, 'title': title, 'keywords': keywords, 'prefer_locations': prefer_locations, 'city': jobalert_city, 'prefer_categories': prefer_categories, 'expected_salary': expected_salary, 'expected_salary_curr': expected_salary_curr, 'jobalert_email': jobalert_email, 'jobalert_contact': jobalert_contact, alert_status: alert_status, job_type: job_type,'country':jobalert_country, '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "PUT"}, function (data) {
                  if (data.status == 'success') {

                      submitBtn.button("reset"); //reset button loading
                      $('.modal').modal('hide'); // close active modal

                      swal({
                        title: "Success",
                        text: txt_job_alert_saved_2,
                        type: "success"
                      }).catch(swal.noop);

                      sendSCLoginEvent(PROFILE_DETAILS,SETTING_ALERT_JOB_EDITED);

                      setTimeout(function () {
                          window.location = canvas_url + "jobseeker/setting";
                      }, timeout_redirect);
                  } else {
                      var text_message = '';
                      for (i = 0; i < data.msg.length; i++) {
                          if (data.msg[i]) {
                              text_message += data.msg[i];
                          }
                      }
                      //swal("Opps!", text_message, "warning");
                      $.notify(text_message, {type: 'danger'});
                      submitBtn.button('reset');
                      submitBtn.closest('.profile-wrap').find('.profile-body').removeClass('load');
                  }
              }, "json")
                .fail( function(xhr, textStatus, errorThrown) {
                    submitBtn.button('reset');
                    showErrorNotification(xhr.status)
                });
            }
        }).form();
    });

    $(".delalert").bind("click", function () {
          var id = $(this).attr('data-id');
          var rec_id = $(this).attr('data-rec-id');
          var rec_type = 'alert';

          var _this = this;

          swal({
            title: txt_are_u_sure,
            text: 'You want to remove this job alert',
            type: 'warning',
            width: 450,
            showCancelButton: true,
            confirmButtonText: txt_confirm_delete,
          }).then(function () {
                var $btn = $(_this);
                var jsonData = {
                    '_token': $('meta[name="csrf-token"]').attr('content'),
                    '_method': "DELETE"
                };
                var request = $.ajax({
                    url: canvas_url + "api/jobseeker/job-alert/" + rec_id + "/" + rec_type,
                    data: jsonData,
                    type: 'DELETE',
                    crossDomain: true,
                    dataType: 'json'
                });
                $btn.addClass('disabled');

                request.done(function (data) {
                    $btn.removeClass('disabled');
                  if (data.status == 'success') {

                      swal({
                        title: "Success",
                        text: txt_alert_delete_notification,
                        type: "success"
                      }).catch(swal.noop);

                      sendSCLoginEvent(PROFILE_DETAILS,SETTING_ALERT_JOB_REMOVED);

                      setTimeout(function () {
                          window.location = canvas_url + "jobseeker/setting";
                        }, timeout_redirect);
                    }
                });

                request.fail(function (jqXHR, textStatus) {
                    $btn.removeClass('disabled');
                    showErrorNotification(jqXHR.status)
                    
                });

          }, function(dismiss){
            if(dismiss == 'cancel'){
                sendSCLoginEvent(PROFILE_DETAILS,SETTING_ALERT_JOB_REMOVE_CANCELED);
            }
         });
    });


    $(".change_phone").bind("click", function () {

        $.validator.setDefaults( {
          submitHandler: function () {
            alert( "submitted!" );
          }
        });

        $( "#form_jobseeker_email" ).validate( {
          rules: {
            change_useremail : {required: true,email: true},
          },
          messages: {
            change_useremail : {required: 'This field is required'},
          },
          submitHandler: function() {

           var change_useremail = $("#change_useremail").val();
           var submitBtn = $(".change_email");
              submitBtn.button("loading");

            $.post(canvas_url + "api/jobseeker/changephone", {'email_address': change_useremail, '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "PUT"}, function (data) {
                  if (data.status == 'success') {

                      submitBtn.button("reset"); //reset button loading
                      $('.modal').modal('hide'); // close active modal


                      swal({
                        title: "Success",
                        text: 'Your email address has been changed successfully. You need to verify this new email address.',
                        type: "success"
                      }).catch(swal.noop);


                      setTimeout(function () {
                          window.location = canvas_url + "jobseeker/setting";
                      }, timeout_redirect);
                  } else {
                      var text_message = '';
                      for (i = 0; i < data.msg.length; i++) {
                          if (data.msg[i]) {
                              text_message += data.msg[i];
                          }
                      }
                      //swal("Opps!", text_message, "warning");
                      $.notify(text_message, {type: 'danger'});
                      submitBtn.button('reset');
                      submitBtn.closest('.profile-wrap').find('.profile-body').removeClass('load');
                  }
              }, "json");
            }
        }).form();
    });

    $(".change_password").bind("click", function () {
        $.validator.setDefaults( {
          submitHandler: function () {
            alert( "submitted!" );
          }
        });

        $( "#form_jobseeker_password" ).validate( {
          rules: {
            old_password : {required: true},
            new_password : {required: true,minlength: 8},
            confirm_password : {equalTo: "#new_password"}
          },
          submitHandler: function() {

              var old_password = $("#old_password").val();
              var new_password = $("#new_password").val();
              var confirm_password = $("#confirm_password").val();

              var submitBtn = $(".change_password");
              submitBtn.button("loading");


              var jsonData = {
                  'old_password': old_password,
                  'new_password': new_password,
                  'confirm_password': confirm_password,
                  '_token': $('meta[name="csrf-token"]').attr('content'),
                  '_method': "PUT"
              };

              var request = $.ajax({
                  url: canvas_url + "api/jobseeker/changepassword",
                  data: jsonData,
                  type: 'PUT',
                  crossDomain: true,
                  dataType: 'json'
              });

              request.done(function (data) {
                  if (data.success == true) {

                      submitBtn.button("reset"); //reset button loading
                      $('.modal').modal('hide'); // close active modal

                      swal({
                          title: "Success",
                          text: txt_pwd_updated,
                          type: "success"
                      }).catch(swal.noop);

                      sendSCLoginEvent(PROFILE_DETAILS,SETTING_CHANGE_PASSWORD_CONFIRM);

                      setTimeout(function () {
                          window.location = canvas_url + "jobseeker/setting";
                      }, timeout_redirect);

                  } else {
                      var msg = txt_got_error;
                      if(typeof data.message !== 'undefined'){
                          msg =  data.message;
                      }
                      $.notify(msg, {type: 'danger'});
                      submitBtn.button('reset');
                      submitBtn.closest('.profile-wrap').find('.profile-body').removeClass('load');
                  }
              });

              request.fail(function (xhr, textStatus, errorThrown) {
                  showErrorNotification(xhr.status)
                  submitBtn.button('reset');
                  submitBtn.closest('.profile-wrap').find('.profile-body').removeClass('load');
              });

          }
        }).form();
    });

    //reset close phone setting
    
    $(".phone_close").bind("click", function () {
        // Contoh clear bagian report message
        $('#change_userphone').val('');
        $(".changephone_requesttac").removeClass('hide');
        $(".changephone_confirmtac").hide();
        $("#form_jobseeker_confirmtac").hide();
        $("#account_login_phone_error_1").hide();
        $("#change_userphone-error").hide();
        $('#change_userphone').css('border', '1px solid #ccc');
        $(".changephone_requesttac").removeClass('disabled');
        $("#change_userphone").attr("disabled",false);
    });


    $(".changephone_requesttac").bind("click", function () {
        $("#form_jobseeker_confirmemailtac").hide();
        $("#form_jobseeker_confirmtac").hide();

        $.validator.setDefaults( {
          submitHandler: function () {
            alert( "submitted!" );
          }
        });

        $( "#form_jobseeker_phone_1" ).validate( {
          rules: {
            change_userphone : {required: true,number: true}
          },
          messages: {
            change_userphone : {required: 'This field is required'},
          },
          submitHandler: function() {

            $("#account_login_phone_error_1").hide();
           var login_phone = $("#change_userphone").intlTelInput("getNumber");
           if (!$("#change_userphone").intlTelInput("isValidNumber"))
           {
              $("#change_userphone").parent().addClass("error");
              $("#account_login_phone_error_1").html('Please enter correct phone number');
              $("#account_login_phone_error_1").show();
              $("#form_jobseeker_confirmtac").hide();
              $("#form_jobseeker_confirmemailtac").hide();
              return false;
           }
           else
           {
              sendSCLoginEvent(PROFILE_DETAILS,SETTING_PHONE_EDIT_TAC);
              var countryData = $("#change_userphone").intlTelInput("getSelectedCountryData");
              selectedDialCode = countryData['dialCode'];
              login_phone = login_phone.replace("+",'');

              var platform_id = $("#imp_platform_id").val();
              if (typeof platform_id=='undefined' || platform_id==null || platform_id=='' || platform_id==0) platform_id = 1;


             var change_userphone = $("#change_userphone").val();
             var submitBtn = $(".changephone_requesttac");
                submitBtn.button("loading");

            $(".changephone_requesttac").addClass('disabled');
            $("#change_userphone").attr("disabled",true);

               var jsonData = {
                   phone: login_phone,
                   '_token': $('meta[name="csrf-token"]').attr('content'),
                   '_method': "POST"
               };

               var request = $.ajax({
                   url: canvas_url+"api/jobseeker/checkPhoneNumber",
                   data: jsonData,
                   type: 'POST',
                   crossDomain: true,
                   dataType: 'json'
               });

               request.done(function (data) {

                   if (data.success) {
                       var jsonData = {
                           platformId: platform_id,
                           sender: 'web',
                           type: 'sms',
                           recipient: login_phone,
                           country_code: selectedDialCode,
                           '_token': $('meta[name="csrf-token"]').attr('content'),
                           '_method': "GET"
                       };

                       var request = $.ajax({
                           url: canvas_url+"api/otvc/generate",
                           data: jsonData,
                           type: 'GET',
                           crossDomain: true,
                           dataType: 'json'
                       });

                       request.done(function (data) {

                           submitBtn.button("reset");
                           $(".changephone_confirmtac").show();

                           if (data.success)
                           {
                               $(".aftertac").removeClass('hide');
                               $(".changephone_requesttac").addClass('hide');
                               $(".changephone_confirmtac").removeClass('hide');
                               $("#form_jobseeker_confirmemailtac").hide();
                               $("#form_jobseeker_confirmtac").show();
                           }
                           else
                           {
                               if (data.status=='validation_error')
                               {
                                   $("#account_login_phone_error_1").html('Please enter correct phone number.');
                               }
                               else
                               {
                                   $("#account_login_phone_error_1").html(data.error);
                               }
                               $("#account_login_phone_error_1").show();
                               $(".changephone_requesttac").removeClass('disabled');
                               $("#change_userphone").attr("disabled",false);
                               $(".aftertac").addClass('hide');
                               $(".changephone_requesttac").removeClass('hide');
                               $(".changephone_confirmtac").addClass('hide');
                               $("#form_jobseeker_confirmemailtac").hide();


                           }
                       });

                       request.fail(function (jqXHR, textStatus) {
                           submitBtn.button("reset");
                           $("#account_login_phone_error_1").html('Please enter correct phone number.');
                           $("#account_login_phone_error_1").show();
                           $(".changephone_requesttac").removeClass('disabled');
                           $("#change_userphone").attr("disabled",false);
                           $(".aftertac").addClass('hide');
                           $(".changephone_requesttac").removeClass('hide');
                           $(".changephone_confirmtac").addClass('hide');
                       });
                   }
                   else
                   {
                       $("#account_login_phone_error_1").html(data.message);
                       $("#account_login_phone_error_1").show();
                       $(".changephone_requesttac").removeClass('disabled');
                       $("#form_jobseeker_confirmemailtac").hide();
                       $("#change_userphone").attr("disabled",false);
                       submitBtn.button("reset");
                   }
               });

               request.fail(function (xhr, textStatus) {
                   submitBtn.button("reset");
                   showErrorNotification(xhr.status);
               });

            }
          }


        }).form();
    });
    
    $(".changephone_confirmtac").bind("click", function () {

        $.validator.setDefaults( {
          submitHandler: function () {
            alert( "submitted!" );
          }
        });

        $( "#form_jobseeker_confirmtac" ).validate( {
          rules: {
            change_userphone_confirmtac : {required: true,number: true}
          },
          messages: {
            change_userphone_confirmtac : {required: 'This field is required'},
          },
          submitHandler: function() {

            $("#account_login_phone_error").hide();
           var login_phone = $("#change_userphone").intlTelInput("getNumber");
           if (!$("#change_userphone").intlTelInput("isValidNumber"))
           {
              $("#change_userphone").parent().addClass("error");
              $("#account_login_phone_error").html('Please enter correct phone number');
              $("#account_login_phone_error").show();
              $("#form_jobseeker_confirmemailtac").hide();
              return false;
           }
           else
           {
              var countryData = $("#change_userphone").intlTelInput("getSelectedCountryData");
              selectedDialCode = countryData['dialCode'];
              login_phone = login_phone.replace("+",'');

              var platform_id = $("#imp_platform_id").val();

              if (typeof platform_id=='undefined' || platform_id==null || platform_id=='' || platform_id==0) platform_id = 1;

             var login_code = $("#change_userphone_confirmtac").val();
             var change_userphone = $("#change_userphone").val();

              var netCoreId = '';
              if(platform_id == 1)
              {
                netCoreId = NC_ACTIVITY_RB_ADD_CONTACT;
              }
              else if(platform_id == 2)
              {
                netCoreId = NC_ACTIVITY_MK_ADD_CONTACT ;
              }

              var name = $("#name").val();
              var email = $("#email").val();
              var city = $("#city").val();
              var age = $("#age").val();
              var old_number = $("#old_number").val();


             var submitBtn = $(".changephone_confirmtac");
                submitBtn.button("loading");

            $(".changephone_confirmtac").addClass('disabled');

              var jsonData = {
                platformId: platform_id,
                sender: 'web',
                type: 'sms',
                recipient: login_phone,
                country_code: selectedDialCode,
                code: login_code,
                '_token': $('meta[name="csrf-token"]').attr('content'),
                '_method': "GET"
              };

              var request = $.ajax({
                url: canvas_url+"api/otvc/verify",
                data: jsonData,
                type: 'GET',
                crossDomain: true,
                dataType: 'json'
              });

              request.done(function (data) {

                if (data.success)
                {
                    $.post(canvas_url + "api/jobseeker/changephone", {'country_code': selectedDialCode,'phone':login_phone, '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "PUT"}, function (data) {
                        if (data.status == 'success') {

                            submitBtn.button("reset"); //reset button loading
                            $('.modal').modal('hide'); // close active modal

                            if(platform_id ==1 || platform_id ==2)
                            {
                              var payload =  {
                                  'NAME': name,
                                  'EMAIL':email,
                                  'MOBILE':login_phone,
                                  'AGE':age,
                                  'CITY':city
                              };
                              $.netcoreTracking(netCoreId, payload, true);
                            }

                            jsonObj = [];
                            item = {}
                            item["old_phone"] = old_number;
                            item["new_phone"] = login_phone;

                            jsonObj.push(item);
           
                            sendSCLoginEvent(PROFILE_DETAILS,SETTING_PHONE_EDITED,jsonObj);



                            swal({
                              title: "Success",
                              text: 'Your contact number has been changed successfully.',
                              type: "success"
                            }).catch(swal.noop);

                            setTimeout(function () {
                                window.location = canvas_url + "jobseeker/setting";
                            }, timeout_redirect);
                        } else {
                            var text_message = '';
                            for (i = 0; i < data.msg.length; i++) {
                                if (data.msg[i]) {
                                    text_message += data.msg[i];
                                }
                            }
                            $.notify(text_message, {type: 'danger'});
                            submitBtn.button('reset');
                            submitBtn.closest('.profile-wrap').find('.profile-body').removeClass('load');
                        }
                    }, "json");
                }
                else
                {
                  submitBtn.button("reset");
                  $("#login_error_tac").show();
                  if (data.status=='validation_error')
                  {

                    $("#account_login_phone_error").html('Please enter correct phone number.');
                  }
                  else
                  {
                    $("#login_error_tac").show();

                  }
                  $("#login_error_tac").show();

                }
              });

              request.fail(function (xhr, textStatus) {

                submitBtn.button("reset");
                showErrorNotification(xhr.status)
              });
            }
          }


        }).form();
    });


    // email close

    $(".email_close").bind("click", function () {
        // Contoh clear bagian report message
        $('#change_useremail').val('');
        $(".changeemail_requesttac").removeClass('hide');
        $(".changeemail_confirmtac").hide();
        $("#form_jobseeker_confirmemailtac").hide();
        $(".change_useremail").removeClass('disabled');
        $("#change_useremail").attr("disabled",false);
        $("#account_login_email_error").hide();
        $("#change_useremail-error").hide();
        $('#change_useremail').css('border', '1px solid #ccc');
    });



    $(".changeemail_requesttac").bind("click", function () {
        $("#form_jobseeker_confirmtac").hide();
        $("#form_jobseeker_confirmemailtac").hide();

          $.validator.setDefaults( {
              submitHandler: function () {
                  alert( "submitted!" );
              }
          });

          $( "#form_jobseeker_email" ).validate( {
              rules: {
                  change_useremail : {required: true,email: true}
              },
              messages: {
                  change_useremail : {required: 'This field is required'},
              },
              submitHandler: function() {


                  var emailInputElement  = $("#change_useremail")
                  var emailInputErrorElement  = $("#account_login_email_error")
                  var loginEmail = emailInputElement.val();
                  var submitBtn = $(".changeemail_requesttac");
                  var confirmTacBtn = $(".changeemail_confirmtac");
                  var afterTac = $(".aftertac");

                  emailInputErrorElement.hide();
                  if (!validateEmail(loginEmail))
                  {
                      emailInputElement.parent().addClass("error");
                      emailInputErrorElement.html(txt_valid_email_error);
                      emailInputErrorElement.show();
                      $("#form_jobseeker_confirmtac").hide();
                      $("#form_jobseeker_confirmemailtac").hide();

                      return false;
                  }
                  else
                  {

                      sendSCLoginEvent(PROFILE_DETAILS,SETTING_EMAIL_EDIT_TAC); 
                      var platform_id = $("#imp_platform_id").val();
                      if (typeof platform_id=='undefined' || platform_id==null || platform_id=='' || platform_id==0) platform_id = 1;

                      submitBtn.button("loading");

                      submitBtn.addClass('disabled');
                      emailInputElement.attr("disabled",true);


                      var jsonData = {
                          type: 'email',
                          email: loginEmail,
                          '_token': $('meta[name="csrf-token"]').attr('content'),
                          '_method': "POST"
                      };

                      var request = $.ajax({
                          url: canvas_url+"api/jobseeker/check-user",
                          data: jsonData,
                          type: 'POST',
                          crossDomain: true,
                          dataType: 'json'
                      });

                      request.done(function (data) {

                          if (data.success) {
                            $("#form_jobseeker_confirmemailtac").show();
                            $(".changeemail_confirmtac").show();
                              var jsonData = {
                                  platformId: platform_id,
                                  sender: 'web',
                                  type: 'email',
                                  recipient: loginEmail,
                                  '_token': $('meta[name="csrf-token"]').attr('content'),
                                  '_method': "GET"
                              };

                              var request = $.ajax({
                                  url: canvas_url + "api/otvc/generate",
                                  data: jsonData,
                                  type: 'GET',
                                  crossDomain: true,
                                  dataType: 'json'
                              });

                              request.done(function (data) {

                                  submitBtn.button("reset");
                                  if (data.success) {
                                      afterTac.removeClass('hide');
                                      submitBtn.addClass('hide');
                                      confirmTacBtn.removeClass('hide');
                                      $(".sentTac").removeClass('hide');
                                      $("#form_jobseeker_confirmemailtac").show();
                                      $("#form_jobseeker_confirmtac").hide();
                                  }
                                  else {
                                      if (data.status == 'validation_error') {
                                          emailInputErrorElement.html(txt_valid_email_error);
                                      }
                                      else {
                                          emailInputErrorElement.html(data.error);
                                      }
                                      emailInputErrorElement.show();
                                      submitBtn.removeClass('disabled');
                                      emailInputElement.attr("disabled", false);
                                      $(".aftertac").addClass('hide');
                                      submitBtn.addClass('hide');
                                      afterTac.removeClass('hide');
                                      confirmTacBtn.removeClass('hide');
                                      $(".haveTac").removeClass('hide');
                                      $("#form_jobseeker_confirmtac").hide();

                                  }
                              });

                              request.fail(function (jqXHR, textStatus) {
                                  submitBtn.button("reset");
                                  emailInputErrorElement.html('Please enter correct email.');
                                  emailInputErrorElement.show();
                                  submitBtn.removeClass('disabled');
                                  emailInputElement.attr("disabled", false);
                                  afterTac.removeClass('hide');
                                  submitBtn.addClass('hide');
                                  confirmTacBtn.removeClass('hide');
                                  $(".haveTac").removeClass('hide');
                              });
                          }else{
                              submitBtn.button("reset");
                              emailInputErrorElement.html(data.message);
                              emailInputErrorElement.show();
                              submitBtn.removeClass('disabled');
                              emailInputElement.attr("disabled", false);

                          }
                      });

                      request.fail(function (xhr) {
                          submitBtn.button("reset");
                          emailInputErrorElement.html(txt_got_error);
                          emailInputErrorElement.show();

                          showErrorNotification(xhr.status);
                      });
                  }
              }


          }).form();
      });

    $(".changeemail_confirmtac").bind("click", function () {
        $("#form_jobseeker_confirmtac").hide();
        $("#form_jobseeker_confirmemailtac").show();

          $.validator.setDefaults( {
              submitHandler: function () {
                  alert( "submitted!" );
              }
          });
          

          $( "#form_jobseeker_confirmemailtac" ).validate( {
              rules: {
                  change_useremail_confirmtac : {required: true,number: true}
              },
              messages: {
                  change_useremail_confirmtac : {required: 'This field is required'},
              },
              submitHandler: function() {

                  $("#account_login_phone_error").hide();
                  $("#form_jobseeker_confirmtac").hide();
                  var emailInputElement  = $("#change_useremail")
                  var emailInputErrorElement  = $("#account_login_email_error")
                  var emailTAcInputElement  = $("#change_useremail_confirmtac")
                  var loginEmail = emailInputElement.val();
                  var submitBtn = $(".changeemail_confirmtac");
                  var old_email = $("#old_email").val();

                  if (!validateEmail(loginEmail))
                  {
                      emailInputElement.parent().addClass("error");
                      emailInputErrorElement.html('Please enter correct email');
                      emailInputErrorElement.show();
                      return false;
                  }
                  else
                  {
                      var platform_id = $("#imp_platform_id").val();
                      if (typeof platform_id=='undefined' || platform_id==null || platform_id=='' || platform_id==0) platform_id = 1;

                      var loginCode = emailTAcInputElement.val();
                      submitBtn.button("loading");
                      submitBtn.addClass('disabled');

                      var jsonData = {
                          platformId: platform_id,
                          sender: 'web',
                          type: 'email',
                          recipient: loginEmail,
                          code: loginCode,
                          '_token': $('meta[name="csrf-token"]').attr('content'),
                          '_method': "GET"
                      };

                      

                      var request = $.ajax({
                          url: canvas_url+"api/otvc/verify",
                          data: jsonData,
                          type: 'GET',
                          crossDomain: true,
                          dataType: 'json'
                      });

                      request.done(function (data) {

                          if (data.success)
                          {


                              var jsonData = {'email_address':loginEmail, '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "PUT"};
                              var changeEmailRequest = $.ajax({
                                  url: canvas_url+"api/jobseeker/changeemail",
                                  data: jsonData,
                                  type: 'PUT',
                                  crossDomain: true,
                                  dataType: 'json'
                              });


                              changeEmailRequest.done(function (data) {
                                  if (data.success == true) {

                                      submitBtn.button("reset"); //reset button loading
                                      $('.modal').modal('hide'); // close active modal


                                      swal({
                                          title: "Success",
                                          text: 'Your contact has been changed successfully.',
                                          type: "success"
                                      }).catch(swal.noop);

                                      jsonObj = [];
                                      item = {}
                                      item["old_email"] = old_email;
                                      item["new_email"] = loginEmail;
                
                                      jsonObj.push(item);
                     
                                      sendSCLoginEvent(PROFILE_DETAILS,SETTING_EMAIL_EDITED,jsonObj);

                                      setTimeout(function () {
                                          window.location = canvas_url + "jobseeker/setting";
                                      }, timeout_redirect);
                                  } else {
                                      emailInputErrorElement.html(data.message);
                                      emailInputErrorElement.show();
                                      submitBtn.button('reset');
                                      submitBtn.closest('.profile-wrap').find('.profile-body').removeClass('load');
                                  }
                              });

                              changeEmailRequest.fail(function () {
                                  submitBtn.button("reset");
                                  emailInputErrorElement.html(txt_got_error);
                                  emailInputErrorElement.show();
                              })
                          }
                          else
                          {
                              submitBtn.button("reset");
                              if (data.status=='validation_error')
                              {
                                  emailInputErrorElement.html(txt_valid_email_error);
                              }
                              else
                              {
                                  emailInputErrorElement.html(data.error);
                              }
                              emailInputErrorElement.show();
                          }
                      });

                      request.fail(function (jqXHR, textStatus) {
                          submitBtn.button("reset");
                          showErrorNotification(jqXHR.status)
                      });
                  }
              }


          }).form();
      });

    $(".change_expstatus").bind("click", function () {
  	  var exp_status = $(this).attr('data-value');
      $.post(canvas_url + "api/jobseeker/field", {'exp_status': exp_status, 'section': '5', '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "POST"}, function (data) {
            if (data.status == 'success') {

                swal({
                  title: "Success",
                  text: 'You experience status has been updated',
                  type: "success"
                }).catch(swal.noop);

                setTimeout(function () {
                    window.location = canvas_url + "jobseeker/profile";
                }, timeout_redirect);
            } else {
                $.notify(data.msg);

            }
      }, "json");
    });
  });

}
